/**
 * RTWO Asset & Token Engine — Service Registry
 */

import type { IASSService } from '../service-interfaces';

export class ASSServiceRegistry {
  private readonly services = new Map<string, IASSService>();

  register(service: IASSService): void {
    this.services.set(service.serviceId, service);
  }

  get<T extends IASSService>(serviceId: string): T | null {
    return (this.services.get(serviceId) as T) ?? null;
  }

  getAll(): IASSService[] {
    return Array.from(this.services.values());
  }

  has(serviceId: string): boolean {
    return this.services.has(serviceId);
  }

  count(): number {
    return this.services.size;
  }
}
